import { getLiteralWithParameters } from 'utils/getLiteral';
import getTextWithLinks from 'utils/getTextWithLinks';

export const getContentForShareDocument = (link) => {
    return getTextWithLinks(getLiteralWithParameters('label_email_share', [link]));
};
